import React, { useState } from 'react';
import { Button, Form, Input, Row, message } from 'antd'
import styles from './index.module.css';
import './an.css'
import { useNavigate } from 'react-router-dom'
import { login } from "./gqls";
import Client from '../../lib/loginGqlClient';

const LoginPage = () => {

	const navigate = useNavigate();

	const [isLoading, setIsLoading] = useState(false)
	React.useEffect(() => {
		const token = sessionStorage.getItem("sessionToken")
		const name = sessionStorage.getItem("userName")
		if (name != null && token != null) {
			setIsLoading(false)
			navigate('../developerCenter', { state: { username: name, sessionToken: token } })
		}
	}, [])
	const onFinish = (values) => {
		if (values.username === "" || values.password === "") {
			message.error('Please enter your email or password.')
			return
		}
		setIsLoading(true)
		sessionStorage.clear()
		Client.mutate({
			mutation: login,
			variables: {
				username: values.username,
				password: values.password
			},
		}).then((res) => {
			if (res !== null) {
				console.log("then",res);
				const name = res.data.loginWithUsernameOrEmail.username
				const token = res.data.loginWithUsernameOrEmail.sessionToken
				const email = res.data.loginWithUsernameOrEmail.email
				const registeredAt = res.data.loginWithUsernameOrEmail.registeredAt
				// const access = res.data.loginWithUsernameOrEmail.access
				const list = res.data.loginWithUsernameOrEmail.access
                let data = [{}];
                list.map((item, index) => {
                    data[index] = item.category  
                })
				sessionStorage.setItem("sessionToken", token)
				sessionStorage.setItem("userName", name)
				sessionStorage.setItem("email", email)
				sessionStorage.setItem("registeredAt", registeredAt)
				sessionStorage.setItem("access", JSON.stringify(data))
				sessionStorage.setItem("key", 'developerCenter/dataNotification')
				openNotification('Sign in developer account successfully.', true, name, token)
				// navigate('../developerCenter' , { state: { username: name, sessionToken:token} })
				window.location.reload()
			}
		}).catch(e => {
			setIsLoading(false)
			console.log("catch",e.message);
			if(e.message.includes('@@__1000137')||e.message.includes('@@__1000138')){
				openNotification('Invalid username or password.', false)	
				// openNotification('Name or email have been registered.', false)	
			}else{
				openNotification('Network timeout, please try again.', false)	
			}
		})
	}
	const onFinishFailed = (errorInfo) => {
		console.log('Failed:', errorInfo);
		openNotification('Sign in failed. Please check your network.', false)

	}

	const openNotification = (placement, type) => {
		if (type) {
			message.success(placement)
		} else {
			message.error(placement)
		}
	};

	function onClick() {
		navigate('../')
	}
	return (
		<div style={{ minWidth: '1440px' }}>
			<Row style={{ height: '60px' }}>
				<img src={require('../../static/img/ic-home-logo.png')} alt="logo"
					style={{ marginTop: '15px', marginLeft: '63px' }} height="34px"
					onClick={onClick} />

			</Row>
			<div style={{ backgroundColor: '#FF5300', width: '100vw', height: '1px' }}></div>
			<div style={{
				width: '500px', height: '580px', margin: ' 0 auto', marginTop: '60px',
				backgroundColor: '#F4F6F8', border: '1px solid #B5B9BE', borderRadius: '5px'
			}}>
				<div className={styles.logo}>
					<img src={require('../../static/img/ic-sign-logo.png')} alt="logo" height={36} />
				</div>
				<div style={{ fontSize: '20px', color: '#2D3238', textAlign: 'center', marginTop: '25px' }}>
					<span >Sign in to your Developer account</span>
				</div>
				<div style={{ width: '430px', marginLeft: '35px', textAlign: 'center', }}>
					<Form
						initialValues={{}}
						onFinish={onFinish}
						onFinishFailed={onFinishFailed}
						autoComplete="off">
						<Form.Item
							label=""
							name="username"
							rules={[{ required: true, message: 'Please input your username!' }]}>
							<Input style={{ height: '60px', marginTop: '50px' }} placeholder="Enter Email" />
						</Form.Item>

						<Form.Item
							label=""
							name="password"
							rules={[{ required: true, message: 'Please input your password!' }]}>
							<Input type='password' style={{ height: '60px', }} placeholder="Password" />
						</Form.Item>
						<Form.Item>
							<Button classname='ant-radio-button-wrapper-checked' disabled={isLoading} style={{ height: '60px', width: '435px', marginTop: '90px', color: '#fff', background: '#FF5300', display: 'flex', justifyContent: 'center', alignItems: 'center', }} htmlType="submit">
								<div style={{ display: isLoading ? 'none' : 'contents' }}>SIGN IN</div>
								<div style={{ display: isLoading ? 'contents' : 'none', }}>
									<img class='img' style={{ width: '40px', height: '40px' }} src={require('../../static/img/ic-login-loading.png')} />

								</div>
							</Button>
						</Form.Item>
					</Form>
				</div>
			</div>
		</div>

	)
}
const Styles = {

	appTitleName: {
		width: '46px',
		height: '22px',
		fontSize: '14px',
		marginRight: '94px',
		marginTop: "23px",
		fontWeight: 'normal',
		lineHeight: '22px',
		border: 'none'
	},
	appTextLarge: {
		display: 'block',
		fontSize: '48px',
		fontWeight: '600',
		color: '#FF5300',
		whiteSpace: "pre-line"
	},

}
export default LoginPage;

